import { ToastColorTypes } from '@insurancemenu/imenu-components-lib/dist/types';
import { generateEdiManually } from 'api/operations/policyService';
import { makeAutoObservable, runInAction } from 'mobx';
import { RootStore } from 'store/rootStore';
import { EdiFile } from 'types/ediService';
import { FileExchangeService } from 'types/exchangeService';

export type ModalType = 'SEND_FILE' | 'GENERATE_FILE';
export default class ReadyToSendEdisStore {
  rootStore: RootStore;
  loading = false;
  exchangeReadyFiles: EdiFile[] = [];
  selectedFile: EdiFile | null = null;
  isModalOpen = false;
  modalType: ModalType | null = null;

  private setLoading(loadingStatus: boolean): void {
    this.loading = loadingStatus;
  }

  public closeModal(): void {
    this.isModalOpen = false;
    this.modalType = null;
    this.selectedFile = null;
  }

  public openModal(modalType: ModalType, file?: EdiFile): void {
    this.modalType = modalType;
    this.isModalOpen = true;
    if (file) this.selectedFile = file;
  }

  public async getExchangeReadyFiles(sponsorId: string): Promise<void> {
    this.setLoading(true);
    const res = await this.rootStore.ediStore.getExchangeReadyFiles(sponsorId);
    runInAction(() => {
      this.exchangeReadyFiles = res;
      this.setLoading(false);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  public buildFileLink(id: string): string {
    return `https://${process.env.REACT_APP_API_BASE_URL}/ediBinary/Prod/download/${id}`;
  }

  public async sendFile(fileId: string, sponsorId: string): Promise<void> {
    this.setLoading(true);
    const warningToastMessage = 'An issue has occurred while attempting to send the file. Please try again later.';

    await this.rootStore.exchangeStore
      .sendFile(fileId, sponsorId, FileExchangeService.EDI)
      .then((res) => {
        if (res.data?.sendFile?.id) {
          this.rootStore.filesTrackingController.showToast(
            'The file has been successfully sent.',
            ToastColorTypes.SUCCESS,
          );
        } else {
          this.rootStore.filesTrackingController.showToast(warningToastMessage, ToastColorTypes.WARNING);
        }
        this.setLoading(false);
      })
      .catch(() => {
        this.rootStore.filesTrackingController.showToast(warningToastMessage, ToastColorTypes.WARNING);
        this.setLoading(false);
      });
  }

  public async generateEdiFile(sponsorId: string, policyIds: string[]): Promise<void> {
    this.setLoading(true);
    const warningToastMessage = 'An issue has occurred while attempting to generate the file. Please try again later.';

    await generateEdiManually(sponsorId, policyIds)
      .then((res) => {
        if (res.data?.generateEdiManually) {
          this.rootStore.filesTrackingController.showToast(
            'The file has been successfully generated.',
            ToastColorTypes.SUCCESS,
          );
        } else {
          this.rootStore.filesTrackingController.showToast(warningToastMessage, ToastColorTypes.WARNING);
        }
        this.setLoading(false);
      })
      .catch(() => {
        this.rootStore.filesTrackingController.showToast(warningToastMessage, ToastColorTypes.WARNING);
        this.setLoading(false);
      });
  }

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {}, { autoBind: true });
  }
}
